import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Footer = ({ noSidebarMargin = false }) => {
  const { user } = useAuth();

  return (
    <footer className={`bg-white border-t border-gray-200 mt-auto ${!noSidebarMargin && user ? 'lg:ml-64' : ''}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-sm text-gray-600">
          {/* Informations principales */}
          <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-2 sm:gap-x-6">
            <span className="font-medium text-primary-600 text-base">Crions D'Couleurs</span>
            <span className="hidden sm:inline text-gray-400">|</span>
            <a href="tel:0629606074" className="hover:text-primary-600 transition flex items-center gap-2">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              06.29.60.60.74
            </a>
            <a href="mailto:cdccolonies@gmail.com" className="hover:text-primary-600 transition flex items-center gap-2">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              cdccolonies@gmail.com
            </a>
          </div>

          {/* Liens légaux */}
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs sm:text-sm">
            <Link to="/mentions-legales" className="hover:text-primary-600 transition">
              Mentions légales
            </Link>
            <Link to="/politique-confidentialite" className="hover:text-primary-600 transition">
              Confidentialité
            </Link>
            <Link to="/cgv" className="hover:text-primary-600 transition">
              CGV
            </Link>
            <span className="text-gray-400">© {new Date().getFullYear()}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
